import * as React from 'react';

import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Text } from '@shared/components/bootstrap';

interface ILoaderProps {
  loading: boolean;
}

class Loader extends React.Component<ILoaderProps> {
  public render() {
    if (this.props.loading) {
      return (
        <Text alignment="center" style="muted" tag="div">
          <FontAwesomeIcon spin icon={faSpinner} className="vehicles-route-matcher__loader" />
        </Text>
      );
    } else {
      return null;
    }
  }
}

export { Loader };
